// 合规自查表 Excel 下载地址：guoqi 首页“下载完整 Excel”与 guoqiComp 详情页“下载EXCEL表格”共用
export const CHECK_EXCEL_URL = 'http://scp.zhongpukeji.cn/f/dashscope/1788515890380-自查表.xlsx'

// 创建隐藏 <a> 触发浏览器下载（同 components/fileList.vue 的做法）
export function downloadFile (url, filename) {
  const eleLink = document.createElement('a')
  eleLink.style.display = 'none'
  eleLink.href = encodeURI(url)
  eleLink.download = filename || ''
  eleLink.target = '_blank'
  document.body.appendChild(eleLink)
  eleLink.click()
  document.body.removeChild(eleLink)
}
